import { Alert, TextField, Typography } from "@mui/material";
import React, { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { CheckButton, Container } from "./styles";
import LoadingOverlay from "../../../../../containers/LoadingOverlay/LoadingOverlay";
import { AlertLineReportDTO } from "../../../../../models/alert-line-report/alert-line-report-dto";
import { PublicAlertLineReportFilter } from "../../../../../models/alert-line-report/public-alert-line-report-filter";
import { AlertLineURLDTO } from "../../../../../models/alert-line-url/alert-line-url-dto";
import { PublicAlertLineReportApiService } from "../../../../../services/alert-line/public-alert-line-report-api.service";
interface Props {
  alertLineURL: AlertLineURLDTO;
  handlePreviousReport: (previousReport: AlertLineReportDTO) => void;
}

interface State {
  loading: boolean;
  error: string;
  reportKey: string;
}

const CheckPreviousAlertLineReport = ({ alertLineURL, handlePreviousReport }: Props) => {
  const tRP = "pages.alert_line_report.previous_alert_line_report";
  const { t } = useTranslation();

  const [state, setState] = useState<State>({
    loading: false,
    error: "",
    reportKey: "",
  });

  const loadPreviousAlertLineReport = useCallback(
    async (reportId) => {
      setState((state) => ({ ...state, previousReportLoading: true }));
      try {
        const response = await new PublicAlertLineReportApiService().loadItems({
          key: reportId,
        } as PublicAlertLineReportFilter);

        if (!response.error && response.items.length > 0) {
          const report = response.items.find(
            (_report) => _report.key === state.reportKey && _report.alertLineURL?.id === alertLineURL.id
          );
          if (report) {
            handlePreviousReport(report);
            setState((state) => ({
              ...state,
              error: "",
            }));
          }
        } else if (response.error) {
          setState((state) => ({
            ...state,
            error: response.error,
          }));
        } else {
          setState((state) => ({
            ...state,
            error: `${t(`${tRP}.key_not_valid`)}`,
          }));
        }
      } catch (error) {
        setState((state) => ({
          ...state,
          error: error as string,
        }));
      } finally {
        setState((state) => ({ ...state, loading: false }));
      }
    },
    [handlePreviousReport, alertLineURL, state.reportKey]
  );

  return (
    <LoadingOverlay loading={state.loading}>
      <Container>
        {state.error && <Alert severity="error">{state.error}</Alert>}
        <Alert severity="warning">{`${t(`${tRP}.block_report_warning`)}`}</Alert>
        <Typography>{`${t(`${tRP}.label`)}`} </Typography>
        <TextField
          value={state.reportKey}
          onChange={(e) => setState((state) => ({ ...state, reportKey: e.target?.value.trim() ?? "" }))}
        />
        <CheckButton
          variant="contained"
          onClick={() => loadPreviousAlertLineReport(state.reportKey)}
        >{`${t(`${tRP}.check`)}`}</CheckButton>
      </Container>
    </LoadingOverlay>
  );
};
export default CheckPreviousAlertLineReport;
